const IconEye = ({ className }) => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M3.17473 10.3418C5.15226 13.6118 7.49163 15.0918 10.1732 15.0918C12.8547 15.0918 15.1941 13.6118 17.1716 10.3418C15.1941 7.07179 12.8547 5.59179 10.1732 5.59179C7.49163 5.59179 5.15226 7.07179 3.17473 10.3418ZM1.56916 9.94899C3.76638 6.10407 6.6265 4.00845 10.1732 4.00845C13.7199 4.00845 16.58 6.10407 18.7772 9.94899C18.9163 10.1924 18.9163 10.4912 18.7772 10.7346C16.58 14.5795 13.7199 16.6751 10.1732 16.6751C6.6265 16.6751 3.76638 14.5795 1.56916 10.7346C1.43007 10.4912 1.43007 10.1924 1.56916 9.94899ZM10.1732 9.55012C9.73595 9.55012 9.38151 9.90456 9.38151 10.3418C9.38151 10.779 9.73595 11.1335 10.1732 11.1335C10.6104 11.1335 10.9648 10.779 10.9648 10.3418C10.9648 9.90456 10.6104 9.55012 10.1732 9.55012ZM7.79818 10.3418C7.79818 9.03011 8.8615 7.96679 10.1732 7.96679C11.4849 7.96679 12.5482 9.03011 12.5482 10.3418C12.5482 11.6535 11.4849 12.7168 10.1732 12.7168C8.8615 12.7168 7.79818 11.6535 7.79818 10.3418Z'
                fill='white'
            />
        </svg>
    );
};

export default IconEye;
